import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import ContactForm from "./ContactForm";

const ContactInfo = ({ icon, label, children }) => (
  <div className="flex items-center">
    <i className="bi">
      <FontAwesomeIcon
        icon={icon}
        className="w-4 h-4 p-2 mr-2 border-2 border-gray-300 text-gray-400 rounded-full"
      />
    </i>
    <p className="p-0">
      <strong className="text-md">{label} :</strong>{" "}
      <span className="text-md">{children}</span>
    </p>
  </div>
);

ContactInfo.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]).isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
};

const Coordonnees = () => {
  return (
    <div className="flex flex-col md:flex-row items-stretch justify-between fade-in">
      <div className="info">
        <div className="mb-5">
          <img
            src="/s-fialon.jpg"
            className="mb-4 w-32 rounded-lg"
            height={150}
            width={150}
            alt="Avatar"
          />
          <h5 className="mb-1 text-xl font-medium leading-tight">
            Sandrine FIALON
          </h5>
          <p className="text-neutral-500 dark:text-neutral-400">
            Spécialiste IT
          </p>
        </div>

        <ContactInfo icon={faLocationDot} label="Adresse">
          Marseille 8e
        </ContactInfo>

        <ContactInfo icon={faPhone} label="Téléphone">
          <a href="tel:0683874742" className="hover:underline">
            06.83.87.47.42
          </a>
        </ContactInfo>

        <ContactInfo icon={faLinkedinIn} label="LinkedIn">
          <a
            href="https://www.linkedin.com/in/fialonsandrine/"
            target="_blank"
            className="hover:underline"
            rel="noreferrer noopener">
            linkedin.com/in/fialonsandrine/
          </a>
        </ContactInfo>
      </div>

      <div className="contact-form php-email-form">
        <div className="flex lg:flex-row flex-col border rounded-xl mb-10 mt-10 md:mt-0 items-top p-5 w-auto shadow-md justify-center">
          <div className="lg:border-r-gray-300 lg:border-r-2 lg:mr-5 lg:p-5">
            <div className="text-bleufonce font-bold text-xl">
              Disponibilités
            </div>
            <div className="stat-desc text-lg text-slate-600">
              Du lundi au vendredi
              <br />
              17h - 19h
            </div>
          </div>
          <div className="lg:border-r-gray-300 lg:border-r-2 lg:mr-5 lg:p-5">
            <div className="text-bleufonce font-bold text-xl">Présentiel</div>
            <div className="stat-desc text-lg text-slate-600">
              Marseille, Aix-en-Provence
            </div>
          </div>
          <div className="lg:p-5">
            <div className="text-bleufonce font-bold text-xl">A distance</div>
            <div className="stat-desc text-lg text-slate-600">
              Toute la France
            </div>
          </div>
        </div>
        <ContactForm />
      </div>
    </div>
  );
};

export default Coordonnees;
